import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { brand } from '../theme'

/**
 * Logo de la empresa.
 *
 * Lee `/logo.jpg` de la carpeta `public`. Se dimensiona por ancho y deja la
 * altura automática: el sello es apaisado (≈1.8:1) y encerrarlo en un cuadrado
 * lo dejaba diminuto.
 *
 * Si el archivo no está —por ejemplo en una instalación nueva— muestra un
 * sello dibujado con los colores de marca, para que el panel nunca quede con
 * un ícono roto.
 */
export function BrandLogo({ width = 180, sx }: { width?: number; sx?: SxProps<Theme> }) {
  const [failed, setFailed] = useState(false)

  if (!failed) {
    return (
      <Box
        component="img"
        src="/logo.jpg"
        alt="Granja Santa María"
        onError={() => setFailed(true)}
        sx={{ width, height: 'auto', display: 'block', borderRadius: 1.5, ...sx }}
      />
    )
  }

  const size = width * 0.45

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        bgcolor: brand.green,
        color: brand.cream,
        border: `2px solid ${brand.olive}`,
        ...sx,
      }}
    >
      <Typography
        component="span"
        sx={{ fontWeight: 700, fontSize: size * 0.34, letterSpacing: 0.5 }}
      >
        GSM
      </Typography>
    </Box>
  )
}
